var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { StepEnum, CurrencyCodeEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { ValidationControllerFactory, validateTrigger, ValidationRules } from "aurelia-validation";
import { RouterConstants } from "../../../../configuration/router.constants";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { OperatorBasicMeta } from "./steps/operator-basic-meta";
import { I18N } from "aurelia-i18n";
import { AttachmentClientService } from "../../../../services/modules/attachements-client.service";
import { Guid } from "../../../../utilities/guid";
import { OperatorAnalytics } from "./steps/operator-analytics";
import { OperatorTransactions } from "./steps/operator-transactions";
import { OperatorPlayers } from "./steps/operator-players";
import { OperatorClientService } from "../../../../services/modules/operator-client.service";
import { OperatorBrands } from "./steps/operator-brands";
import { LotteryInsurance } from "../brand/steps/lottery-insurance";
import { OperatorChangeLog } from "./steps/operator-changelog";
import { BrandLotteries } from "../brand/steps/brand-lotteries";
import { LotteryInsurancePrint } from "../brand/steps/lottery-insurance-print";
import { InsuranceDataHandler } from "../brand/insurance-handler";
import { OperatorTicketLines } from "./steps/operator-ticket-lines";
import { BaseClaims } from "../../../../constants/authentication/base-claims";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { Billing } from "../brand/steps/billing";
import * as Enumerable from "linq";
import { LotteryPlatformClaims } from "../../../../constants/modules/lotteryplatform.claims";
import { LookupValueRequest, LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { BrandBundles } from "../brand/steps/brand-bundles";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { OperatorSettings } from "./steps/operator-settings";
var Operator = /** @class */ (function (_super) {
    __extends(Operator, _super);
    function Operator(dialogClientService, router, tokenClient, bindingEngine, notificationService, eventAggregator, userClaimsService, operatorClientService, operatorBasicMeta, operatorAnalytics, operatorTransactions, operatorBrands, attachmentClientService, operatorChangeLog, operatorSettings, lotteryInsurance, brandLotteries, brandBundles, lotteryInsurancePrint, insuranceDataHandler, operatorPlayers, i18N, operatorTicketLines, billing, lookupClientService, validationControllerFactory) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.router = router;
        _this.tokenClient = tokenClient;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.userClaimsService = userClaimsService;
        _this.operatorClientService = operatorClientService;
        _this.operatorBasicMeta = operatorBasicMeta;
        _this.operatorAnalytics = operatorAnalytics;
        _this.operatorTransactions = operatorTransactions;
        _this.operatorBrands = operatorBrands;
        _this.attachmentClientService = attachmentClientService;
        _this.operatorChangeLog = operatorChangeLog;
        _this.operatorSettings = operatorSettings;
        _this.lotteryInsurance = lotteryInsurance;
        _this.brandLotteries = brandLotteries;
        _this.brandBundles = brandBundles;
        _this.lotteryInsurancePrint = lotteryInsurancePrint;
        _this.operatorPlayers = operatorPlayers;
        _this.operatorTicketLines = operatorTicketLines;
        _this.billing = billing;
        _this.lookupClientService = lookupClientService;
        _this.validationControllerFactory = validationControllerFactory;
        _this.activityLogEntitiesSave = [EntityTypes.Operator];
        _this.controller = null;
        _this.lotteryInsurance.insuranceDataHandler = insuranceDataHandler;
        _this.lotteryInsurance.isEditable = _this.userClaimsService.hasPermission(LotteryPlatformClaims.EditLotteryInsurance);
        _this.lotteryInsurancePrint.insuranceDataHandler = insuranceDataHandler;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Operator.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Operator.prototype.attached = function () {
        var _this = this;
        if (!this.item.operatorId) {
            var request = new LookupValueRequest();
            request.lookupValueQuery = LookupValueQuery.currencies;
            this.setDefaultValues();
            return this.lookupClientService.getLookup(request).then(function (x) {
                _this.item.defaultCurrencyId =
                    Enumerable.from(x.values).firstOrDefault(function (x) { return x.name.toLowerCase() == _this.tokenClient.defaultCurrencyName().toLocaleLowerCase(); }).id;
                _this.unitOfWorkObserver.addChange("defaultCurrencyId", _this.item.defaultCurrencyId, null);
            });
        }
        this.canDeleteOperator = this.userClaimsService.hasPermission(LotteryPlatformClaims.DeleteOperator);
        return _super.prototype.attached.call(this);
    };
    Operator.prototype.updatePermissions = function () {
        if ('operatorId' in this.item) {
            var isEditable = false;
            if (this.userClaimsService.hasPermission(LotteryPlatformClaims.EditOperators))
                isEditable = true;
            else {
                isEditable = !(this.userClaimsService.hasPermission(LotteryPlatformClaims.EditOperators));
                // && !this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewOperators));
            }
            if (this.item) {
                this.item.isEditable = isEditable;
            }
            this.billing.isEditable = isEditable;
            this.lotteryInsurance.isEditable = isEditable;
        }
    };
    Operator.prototype.deleteOperator = function () {
        var _this = this;
        require("../dialogs/delete-modal"); // this is to show delete modal dialog
        return new Promise(function (resolve, reject) {
            if (_this.item.operatorId) {
                _this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                    delete: function () { return new Promise(function (resolve, reject) {
                        _this.operatorClientService.delete({ operatorId: _this.item.operatorId }).then(function (response) {
                            if (response.deleteSuccessfully) {
                                _this.notificationService.show(_this.i18N.tr("operator-delete-notification-title"), _this.i18N.tr("operator-delete-notification-message-success"), NotificationType.Success);
                                _this.router.navigateToRoute(_this.getListRoute());
                                resolve();
                            }
                            else {
                                _this.notificationService.show(_this.i18N.tr("operator-delete-notification-title"), _this.i18N.tr("operator-delete-notification-message-error"), NotificationType.Error);
                                reject();
                            }
                        }).catch(function () {
                            _this.notificationService.show(_this.i18N.tr("operator-delete-notification-title"), _this.i18N.tr("operator-delete-notification-message-error"), NotificationType.Error);
                            reject();
                        });
                    }); }
                });
            }
            else {
                resolve();
            }
        });
    };
    //needed this as defaults set in defaultOperator where not being picked up by UOW
    Operator.prototype.setDefaultValues = function () {
        var _this = this;
        setTimeout(function () {
            _this.unitOfWorkObserver.addChange("operatorMargin", 0.15, null);
            _this.unitOfWorkObserver.addChange("platformMargin", 0.50, null);
            _this.unitOfWorkObserver.addChange("winningsThreshold", 500, null);
            _this.unitOfWorkObserver.addChange("defaultCurrencyId", 1, null);
        }, 500);
    };
    Object.defineProperty(Operator.prototype, "defaultOperator", {
        get: function () {
            return {
                operatorId: 0,
                name: "",
                createdDate: new Date(),
                operatorMargin: 0.15,
                platformMargin: 0.50,
                minOperatorMargin: null,
                minPlatformMargin: null,
                maxOperatorMargin: null,
                maxPlatformMargin: null,
                instantGamesOperatorMargin: null,
                instantGamesPlatformMargin: null,
                bundlesOperatorMargin: null,
                bundlesPlatformMargin: null,
                syndicatesOperatorMargin: null,
                syndicatesPlatformMargin: null,
                sweepstakesOperatorMargin: null,
                sweepstakesPlatformMargin: null,
                operatorCreditTransfers: [],
                failOnInsufficientCredit: false,
                insufficientCreditAlertEmail: null,
                firstInsufficientCreditAlertInEuro: null,
                secondInsufficientCreditAlertInEuro: null,
                instantGamesMinOperatorMargin: null,
                instantGamesMinPlatformMargin: null,
                instantGamesMaxOperatorMargin: null,
                instantGamesMaxPlatformMargin: null,
                isInstantGamesOperatorMarginPercentage: false,
                isInstantGamesPlatformMarginPercentage: false,
                isInstantGamesOperatorMarginPercentageGross: false,
                isInstantGamesPlatformMarginPercentageGross: false,
                bundlesMinOperatorMargin: null,
                bundlesMinPlatformMargin: null,
                bundlesMaxOperatorMargin: null,
                bundlesMaxPlatformMargin: null,
                isBundlesOperatorMarginPercentage: false,
                isBundlesPlatformMarginPercentage: false,
                isBundlesOperatorMarginPercentageGross: false,
                isBundlesPlatformMarginPercentageGross: false,
                syndicatesMinOperatorMargin: null,
                syndicatesMinPlatformMargin: null,
                syndicatesMaxOperatorMargin: null,
                syndicatesMaxPlatformMargin: null,
                isSyndicatesOperatorMarginPercentage: false,
                isSyndicatesPlatformMarginPercentage: false,
                isSyndicatesOperatorMarginPercentageGross: false,
                isSyndicatesPlatformMarginPercentageGross: false,
                sweepstakesMinOperatorMargin: null,
                sweepstakesMinPlatformMargin: null,
                sweepstakesMaxOperatorMargin: null,
                sweepstakesMaxPlatformMargin: null,
                isSweepstakesOperatorMarginPercentage: false,
                isSweepstakesPlatformMarginPercentage: false,
                isSweepstakesOperatorMarginPercentageGross: false,
                isSweepstakesPlatformMarginPercentageGross: false,
                isOperatorMarginPercentagePlatformAndInsurance: false,
                isInstantGamesOperatorMarginPercentagePlatformAndInsurance: false,
                isBundlesOperatorMarginPercentagePlatformAndInsurance: false,
                isSyndicatesOperatorMarginPercentagePlatformAndInsurance: false,
                isSweepstakesOperatorMarginPercentagePlatformAndInsurance: false,
                winningsThreshold: 500,
                entityType: EntityTypes.Operator,
                isOperatorMarginPercentage: false,
                isOperatorMarginPercentageGross: false,
                identifier: Guid.generateGuid(),
                operatorUsers: [],
                isPlatformMarginPercentage: false,
                isPlatformMarginPercentageGross: false,
                lotteryPriceTierInsurancePolicies: [],
                defaultCurrencyId: 1,
                enableAgent: false,
                enableRequestRetry: false,
                //noOfTimesToRetry: 0,
                operatorCurrencies: [],
                instantGameStuckRoundsAfterHours: 0,
                operatorNotificationUrl: null,
                operatorNotificationApiKey: null
            };
        },
        enumerable: false,
        configurable: true
    });
    Operator.prototype.initValidations = function (newItem) {
        var _this = this;
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Operator name is required.")
            .ensure(function (x) { return x.operatorMargin; }).required().withMessage("Operator Margin is required.")
            .ensure(function (x) { return x.platformMargin; }).required().withMessage("Platform Margin is required.")
            .ensure(function (x) { return x.winningsThreshold; }).required().withMessage("Winning Threshold is required.")
            .ensure(function (x) { return x.defaultCurrencyId; }).required().withMessage("Operator Currency is required.")
            .satisfies(function (x) {
            if (_this.item.operatorNotificationUrl != null && _this.item.operatorNotificationUrl.trim().length > 0) {
                if (_this.item.operatorNotificationApiKey == null || _this.item.operatorNotificationApiKey.trim().length === 0)
                    return false;
            }
            return true;
        }).withMessage("The Operator notification API key cannot be empty if the operator notification URL is set")
            .satisfies(function (x) {
            if (_this.item.operatorNotificationApiKey != null && _this.item.operatorNotificationApiKey.trim().length > 0) {
                if (_this.item.operatorNotificationUrl == null || _this.item.operatorNotificationUrl.trim().length === 0)
                    return false;
            }
            return true;
        }).withMessage("The Operator notification Url cannot be empty because the api key is set")
            .satisfies(function (x) {
            if (_this.item.instantGameStuckRoundsAfterHours != null && _this.item.instantGameStuckRoundsAfterHours > 0) {
                if (_this.item.operatorNotificationUrl == null || _this.item.operatorNotificationUrl.trim().length === 0)
                    return false;
            }
            return true;
        }).withMessage("The Operator notification details has to be set for the stuck rounds after hours")
            .on(newItem)
            .rules;
    };
    Operator.prototype.isNewOperator = function () {
        return 'operatorId' in this.item && this.item.operatorId != 0;
    };
    Operator.prototype.getSteps = function () {
        return [
            {
                title: this.i18N.tr("operator-basic-meta"),
                step: StepEnum.OperatorAnalytics,
                vm: this.operatorBasicMeta,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorOverview),
                view: "../../app/admin/operator/steps/operator-basic-meta.html"
            },
            {
                loadOnceClicked: true,
                title: this.item.enableAgent ? 'Super Agents' : this.i18N.tr("operator-brands"),
                step: StepEnum.OperatorBrands,
                vm: this.operatorBrands,
                // hide this operator brand list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorBrands) && this.isNewOperator(),
                view: "../../app/admin/operator/steps/operator-brands.html"
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("operator-transactions"),
                step: StepEnum.OperatorTransactions,
                vm: this.operatorTransactions,
                // hide this operator transaction list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorTransactions) && this.isNewOperator(),
                view: "../../app/admin/operator/steps/operator-transactions.html"
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-lotteries-operator"),
                step: StepEnum.BrandLotteries,
                vm: this.brandLotteries,
                // hide this operator brand lottery list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorLotteryTicketPricing) && this.isNewOperator(),
                view: '../../app/admin/brand/steps/brand-lotteries.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("lottery-insurance"),
                step: StepEnum.BrandLotteryInsurance,
                vm: this.lotteryInsurance,
                // hide this operator lottery insurance list tab when creating new operator
                show: this.tokenClient.isSuperAdmin() && this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorLotteryInsurance) && this.isNewOperator(),
                view: "../../app/admin/brand/steps/lottery-insurance.html"
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("lottery-cost-summary"),
                step: StepEnum.BrandLotteryInsuranceCosts,
                vm: this.lotteryInsurancePrint,
                // hide this operator lottery ticket cost list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorLotteryTicketCosts) && this.isNewOperator(),
                view: '../../app/admin/brand/steps/lottery-insurance-print.html'
            },
            {
                loadOnceClicked: true,
                title: this.item.enableAgent ? 'Agents' : this.i18N.tr("operator-players"),
                step: StepEnum.OperatorPlayers,
                vm: this.operatorPlayers,
                // hide this operator players list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorPlayers) && this.isNewOperator(),
                view: "../../app/admin/operator/steps/operator-players.html"
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("ticket-lines"),
                step: StepEnum.OperatorTicketLines,
                vm: this.operatorTicketLines,
                // hide this operator ticket sales list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorTicketSales) && this.isNewOperator(),
                view: "../../app/admin/operator/steps/operator-ticket-lines.html"
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("change-log"),
                step: StepEnum.OperatorChangeLog,
                vm: this.operatorChangeLog,
                // hide this operator change log list tab when creating new operator
                show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory) && this.isNewOperator(),
                view: "../../app/admin/operator/steps/operator-changelog.html"
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("billing"),
                step: StepEnum.OperatorBilling,
                vm: this.billing,
                // hide this operator billing list tab when creating new operator
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorBilling) && this.isNewOperator(),
                view: '../../app/admin/brand/steps/billing.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("operator-setting"),
                step: StepEnum.OperatorSettings,
                vm: this.operatorSettings,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorOverview),
                view: '../../app/admin/operator/steps/operator-settings.html'
            }
        ];
    };
    Operator.prototype.initializeItemOverride = function (newItem) {
        if (newItem && !newItem.createdDate) {
            newItem.createdDate = new Date();
        }
        this.initValidations(newItem);
        var euro = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == CurrencyCodeEnum.Eur.toLowerCase(); });
        var doesNotHaveEuroCurrency = euro && newItem && newItem.operatorCurrencies && !Enumerable.from(newItem.operatorCurrencies).any(function (x) { return x.currencyId == euro.currencyId; });
        if (doesNotHaveEuroCurrency)
            this.addEuroCurrency(newItem);
    };
    Operator.prototype.initializeItemOverrideForUpdate = function (newItem) {
        this.initValidations(newItem);
    };
    Operator.prototype.addEuroCurrency = function (newItem) {
        var euro = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == CurrencyCodeEnum.Eur.toLowerCase(); });
        if (euro)
            newItem.operatorCurrencies.push({
                currencyId: euro.currencyId
            });
    };
    // Inherited
    Operator.prototype.getItem = function (id) {
        var request = { id: id };
        var promise = this.operatorClientService.getOperator(request);
        return promise;
    };
    Operator.prototype.getItemId = function () {
        return this.item.operatorId;
    };
    Operator.prototype.getEntityType = function () {
        return EntityTypes.Operator;
    };
    Operator.prototype.saveItem = function (id, changes) {
        var request = { id: id, changes: changes };
        return this.operatorClientService.save(request);
    };
    Operator.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageOperator;
    };
    Operator.prototype.initializeItemForCreate = function () {
        return this.defaultOperator;
    };
    Operator.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListOperators;
    };
    Operator.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        this.controller.validate({ object: this.item, rules: this.rules }).then(function (result) {
            resolve(result.valid, _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    Operator = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Router, TokenClient,
            BindingEngine,
            NotificationClientService,
            EventAggregator,
            UserClaimsService,
            OperatorClientService,
            OperatorBasicMeta,
            OperatorAnalytics,
            OperatorTransactions,
            OperatorBrands,
            AttachmentClientService,
            OperatorChangeLog,
            OperatorSettings,
            LotteryInsurance,
            BrandLotteries,
            BrandBundles,
            LotteryInsurancePrint,
            InsuranceDataHandler,
            OperatorPlayers, I18N,
            OperatorTicketLines,
            Billing,
            LookupClientService,
            ValidationControllerFactory])
    ], Operator);
    return Operator;
}(BaseEntity));
export { Operator };
